export default "__VITE_ASSET__DMwy8x8s__"